import { apiRequest } from './apiWrapper'
import { API_METHOD, API_END_POINT } from '../utils/constants'

export const fetchPopularMovies = async (id) => {
  const response = await apiRequest({
    method: API_METHOD.Get,
    url: API_END_POINT.PopularMovies
  })
  return response
}

export const fetchPopularCharacters = async (id) => {
  const response = await apiRequest({
    method: API_METHOD.Get,
    url: API_END_POINT.PopularCharacter
  })
  return response
}

export const fetchSuggested = async () => {
  const response = await apiRequest({
    method: API_METHOD.Get,
    url: API_END_POINT.SuggestedRail
  })
  return response
}

export const fetchSuggestedForFaceSwap = async () => {
  const response = await apiRequest({
    method: API_METHOD.Get,
    url: API_END_POINT.SuggestedFor
  })
  return response
}

export const fetchRemixTools = async (type) => {
  const response = await apiRequest({
    method: API_METHOD.Get,
    url: "remix_tools",
    params:{type:type}
  })
  return response
}
